export default "__VITE_ASSET__6c3c7b70__"